module.exports = __webpack_public_path__ + "img/folleto2.626c8327.png";